import { Paper, PaperProps, styled } from "@mui/material";

export const StyledPaper = styled(Paper)<PaperProps>(({ theme }) => ({
  borderRadius: theme.spacing(3),
  boxShadow: `0px 5px 50px rgba(0, 67, 101, 0.08), 0px 2px 6px rgba(130, 169, 188, 0.08)`,
  backgroundColor: theme.palette.custom.grey.accentBlock,
  padding: "1rem",
}));
